module.exports = __webpack_public_path__ + "static/media/dashboard.39401c44.svg";